import request from '@/utils/request'

let ActiveApi = {
  /*活动列表*/
  activeList(data, errorback) {
    return request._post('/shop/product.active/index', data, errorback);
  },
  /*活动核销记录列表*/
  activeRecordList(data, errorback) {
    return request._post('/shop/product.active/record', data, errorback);
  },
  /*店员列表*/
  cancelList(data, errorback) {
    return request._post('/shop/product.cancel/index', data, errorback);
  },
  /*店员添加*/
  addCancel(data, errorback) {
    return request._post('/shop/product.cancel/add', data, errorback);
  },
  /*店员详情*/
  cancelAddDetail(data, errorback) {
    return request._get('/shop/product.cancel/add', data, errorback);
  },
  /*店员详情*/
  cancelDetail(data, errorback) {
    return request._get('/shop/product.cancel/edit', data, errorback);
  },
  /*店员编辑*/
  editCancel(data, errorback) {
    return request._post('/shop/product.cancel/edit', data, errorback);
  },
  /*删除店员*/
  deleteCancel(data, errorback) {
    return request._post('/shop/product.cancel/delete', data, errorback);
  },
  /*活动参与用户列表*/
  activeUserList(data, errorback) {
    return request._post('/shop/product.active/user', data, errorback);
  },
}
export default ActiveApi;



// WEBPACK FOOTER //
// ./src/api/active.js